var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_vm._t("before"),_vm._l((_vm.pages),function(page){return _c('v-tab',{key:page.meta.slug,attrs:{"to":page.path}},[_vm._v(" "+_vm._s(page.meta.title || page.meta.slug || page.name)+" ")])}),_vm._t("default"),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }